import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import MeasureDropdown from '../../MeasureDropdown'

// X / Y axis picker for ScatterTool. Thin wrapper around the shared
// MeasureDropdown -- the parent (ScatterTool) builds the sectioned
// option list via buildMeasureSections, this just exposes two
// dropdowns and lets each disable the other's current value to
// enforce X != Y at the UI level (the change handlers also enforce
// it, since the picker is one of several ways to set an axis).

const useStyles = makeStyles(() => ({
  row: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
  },
  axisGroup: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4
  },
  label: {
    fontSize: 11,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    color: 'var(--color-neutral-500, #888)'
  }
}))

export default function AxisPicker ({
  axisSections,
  axisXId,
  axisYId,
  onAxisXChange,
  onAxisYChange,
  onMoreX,
  onMoreY
}) {
  const classes = useStyles()
  const allOptions = axisSections.flatMap(s => s.options)
  const xCurrent = allOptions.find(o => o.id === axisXId)
  const yCurrent = allOptions.find(o => o.id === axisYId)

  return (
    <div className={classes.row}>
      <div className={classes.axisGroup}>
        <span className={classes.label}>X</span>
        <MeasureDropdown
          sections={axisSections}
          currentId={axisXId}
          excludeId={axisYId}
          triggerLabel={xCurrent?.label}
          triggerAriaLabel='Choose X axis measure'
          onChange={onAxisXChange}
          onMore={onMoreX}
        />
      </div>
      <div className={classes.axisGroup}>
        <span className={classes.label}>Y</span>
        <MeasureDropdown
          sections={axisSections}
          currentId={axisYId}
          excludeId={axisXId}
          triggerLabel={yCurrent?.label}
          triggerAriaLabel='Choose Y axis measure'
          onChange={onAxisYChange}
          onMore={onMoreY}
        />
      </div>
    </div>
  )
}

AxisPicker.propTypes = {
  axisSections: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired
  })).isRequired,
  axisXId: PropTypes.string,
  axisYId: PropTypes.string,
  onAxisXChange: PropTypes.func.isRequired,
  onAxisYChange: PropTypes.func.isRequired,
  onMoreX: PropTypes.func,
  onMoreY: PropTypes.func
}
